module.exports = __webpack_public_path__ + "media/images/clutch_kits/KAWE-43a911ae95aca0493d31dfc1007ac456.jpg";